export const MESSAGES = {
    TOOLTIPS: {
        MANDATORY_PLACEHOLDER:
            'Insert a mandatory placeholder that must be included in the template',
        MILESTONE_PLACEHOLDER: 'Insert a placeholder for the milestone payment table',
    },
} as const;
